export default {
  "zh_TW": {
    "home": "TokenTrend 首頁",
    "lightMode": "切換淺色模式",
    "darkMode": "切換深色模式",
    "closeSearch": "關閉搜尋",
    "search": "搜尋幣種",
    "workspace": "市場工作空間",
    "marketTitle": "市場行情",
    "marketIntro": "行情、情緒與資金動向。",
    "collapse": "收起",
    "switchPage": "切換頁面",
    "pageCategories": "頁面分類",
    "mainNavigation": "主要導覽",
    "groups": {
      "market": "行情",
      "contracts": "合約",
      "onchain": "鏈上",
      "news": "資訊",
      "account": "我的"
    },
    "pages": {
      "market": "市場行情",
      "collect": "自選收藏",
      "platform": "交易平台",
      "toolOutsidePrice": "場外價格",
      "toolOutsideDisk": "外盤數據",
      "toolSentimentIndex": "情緒指數",
      "burst": "爆倉",
      "manyEmpty": "多空",
      "hyperliquid": "Hyperliquid巨鯨監控",
      "hyperliquidDetails": "Hyperliquid持倉",
      "rate": "資金費率",
      "toolLargeIncrease": "大戶增倉",
      "toolLargeDecrease": "大戶減倉",
      "publicChain": "公鏈",
      "newChain": "新幣",
      "whale": "巨鯨與持倉",
      "trace": "地址追蹤",
      "inscription": "銘文",
      "toolStableCoin": "穩定幣",
      "toolCompanyHoldings": "公司持倉",
      "toolMTGoxMonitor": "門頭溝監控",
      "toolBlockChainBrowser": "區塊鏈瀏覽器",
      "consult": "資訊",
      "calendar": "經濟日曆",
      "forum": "社群",
      "application": "應用資源",
      "my": "帳戶中心",
      "tool": "工具",
      "hitNewRobot": "打新機器人",
      "contractCheck": "合約檢查"
    }
  },
  "en_US": {
    "home": "TokenTrend home",
    "lightMode": "Switch to light mode",
    "darkMode": "Switch to dark mode",
    "closeSearch": "Close search",
    "search": "Search coins",
    "workspace": "Market workspace",
    "marketTitle": "Market overview",
    "marketIntro": "Prices, sentiment and capital flows.",
    "collapse": "Collapse",
    "switchPage": "Switch page",
    "pageCategories": "Page categories",
    "mainNavigation": "Main navigation",
    "groups": {
      "market": "Markets",
      "contracts": "Futures",
      "onchain": "On-chain",
      "news": "News",
      "account": "Account"
    },
    "pages": {
      "market": "Markets",
      "collect": "Watchlist",
      "platform": "Exchanges",
      "toolOutsidePrice": "OTC prices",
      "toolOutsideDisk": "Global markets",
      "toolSentimentIndex": "Sentiment index",
      "burst": "Liquidations",
      "manyEmpty": "Long/short",
      "hyperliquid": "Hyperliquid whale monitor",
      "hyperliquidDetails": "Hyperliquid positions",
      "rate": "Funding rates",
      "toolLargeIncrease": "Large position increases",
      "toolLargeDecrease": "Large position decreases",
      "publicChain": "Blockchains",
      "newChain": "New tokens",
      "whale": "Whales & holdings",
      "trace": "Address tracking",
      "inscription": "Inscriptions",
      "toolStableCoin": "Stablecoins",
      "toolCompanyHoldings": "Corporate holdings",
      "toolMTGoxMonitor": "Mt. Gox monitor",
      "toolBlockChainBrowser": "Block explorers",
      "consult": "News",
      "calendar": "Economic calendar",
      "forum": "Community",
      "application": "Apps & resources",
      "my": "Account centre",
      "tool": "Tools",
      "hitNewRobot": "New token bot",
      "contractCheck": "Contract checks"
    }
  },
  "zh_CN": {
    "home": "TokenTrend 首页",
    "lightMode": "切换浅色模式",
    "darkMode": "切换深色模式",
    "closeSearch": "关闭搜索",
    "search": "搜索币种",
    "workspace": "市场工作空间",
    "marketTitle": "市场行情",
    "marketIntro": "行情、情绪与资金动向。",
    "collapse": "收起",
    "switchPage": "切换页面",
    "pageCategories": "页面分类",
    "mainNavigation": "主要导航",
    "groups": {
      "market": "行情",
      "contracts": "合约",
      "onchain": "链上",
      "news": "资讯",
      "account": "我的"
    },
    "pages": {
      "market": "市场行情",
      "collect": "自选收藏",
      "platform": "交易平台",
      "toolOutsidePrice": "场外价格",
      "toolOutsideDisk": "外盘数据",
      "toolSentimentIndex": "情绪指数",
      "burst": "爆仓",
      "manyEmpty": "多空",
      "hyperliquid": "Hyperliquid巨鲸监控",
      "hyperliquidDetails": "Hyperliquid持仓",
      "rate": "资金费率",
      "toolLargeIncrease": "大户增仓",
      "toolLargeDecrease": "大户减仓",
      "publicChain": "公链",
      "newChain": "新币",
      "whale": "巨鲸与持仓",
      "trace": "地址追踪",
      "inscription": "铭文",
      "toolStableCoin": "稳定币",
      "toolCompanyHoldings": "公司持仓",
      "toolMTGoxMonitor": "门头沟监控",
      "toolBlockChainBrowser": "区块链浏览器",
      "consult": "资讯",
      "calendar": "经济日历",
      "forum": "社区",
      "application": "应用资源",
      "my": "账户中心",
      "tool": "工具",
      "hitNewRobot": "打新机器人",
      "contractCheck": "合约检查"
    }
  },
  "ja_JP": {
    "home": "TokenTrend ホーム",
    "lightMode": "ライトモードに切り替え",
    "darkMode": "ダークモードに切り替え",
    "closeSearch": "検索を閉じる",
    "search": "暗号資産を検索",
    "workspace": "マーケットワークスペース",
    "marketTitle": "マーケット概要",
    "marketIntro": "価格、センチメント、資金の流れ。",
    "collapse": "閉じる",
    "switchPage": "ページ切替",
    "pageCategories": "ページ分類",
    "mainNavigation": "メインナビゲーション",
    "groups": {
      "market": "市場",
      "contracts": "先物",
      "onchain": "オンチェーン",
      "news": "ニュース",
      "account": "アカウント"
    },
    "pages": {
      "market": "市場価格",
      "collect": "ウォッチリスト",
      "platform": "取引所",
      "toolOutsidePrice": "OTC価格",
      "toolOutsideDisk": "海外市場",
      "toolSentimentIndex": "センチメント指数",
      "burst": "清算",
      "manyEmpty": "ロング・ショート",
      "hyperliquid": "Hyperliquidクジラ監視",
      "hyperliquidDetails": "Hyperliquidポジション",
      "rate": "資金調達率",
      "toolLargeIncrease": "大口ポジション増加",
      "toolLargeDecrease": "大口ポジション減少",
      "publicChain": "ブロックチェーン",
      "newChain": "新規トークン",
      "whale": "大口保有者・保有量",
      "trace": "アドレス追跡",
      "inscription": "インスクリプション",
      "toolStableCoin": "ステーブルコイン",
      "toolCompanyHoldings": "企業保有量",
      "toolMTGoxMonitor": "Mt. Gox監視",
      "toolBlockChainBrowser": "ブロックエクスプローラー",
      "consult": "ニュース",
      "calendar": "経済カレンダー",
      "forum": "コミュニティ",
      "application": "アプリ・リソース",
      "my": "アカウント",
      "tool": "ツール",
      "hitNewRobot": "新規トークンボット",
      "contractCheck": "コントラクト確認"
    }
  },
  "ko_KR": {
    "home": "TokenTrend 홈",
    "lightMode": "라이트 모드로 전환",
    "darkMode": "다크 모드로 전환",
    "closeSearch": "검색 닫기",
    "search": "코인 검색",
    "workspace": "시장 작업 공간",
    "marketTitle": "시장 개요",
    "marketIntro": "시세, 투자 심리 및 자금 흐름.",
    "collapse": "접기",
    "switchPage": "페이지 전환",
    "pageCategories": "페이지 분류",
    "mainNavigation": "주요 탐색",
    "groups": {
      "market": "시장",
      "contracts": "선물",
      "onchain": "온체인",
      "news": "뉴스",
      "account": "계정"
    },
    "pages": {
      "market": "시장 시세",
      "collect": "관심 목록",
      "platform": "거래소",
      "toolOutsidePrice": "장외 가격",
      "toolOutsideDisk": "해외 시장",
      "toolSentimentIndex": "심리 지수",
      "burst": "청산",
      "manyEmpty": "롱/숏",
      "hyperliquid": "Hyperliquid 고래 모니터링",
      "hyperliquidDetails": "Hyperliquid 포지션",
      "rate": "펀딩 비율",
      "toolLargeIncrease": "대규모 포지션 증가",
      "toolLargeDecrease": "대규모 포지션 감소",
      "publicChain": "블록체인",
      "newChain": "신규 토큰",
      "whale": "고래 및 보유량",
      "trace": "주소 추적",
      "inscription": "인스크립션",
      "toolStableCoin": "스테이블코인",
      "toolCompanyHoldings": "기업 보유량",
      "toolMTGoxMonitor": "Mt. Gox 모니터",
      "toolBlockChainBrowser": "블록 탐색기",
      "consult": "정보",
      "calendar": "경제 캘린더",
      "forum": "커뮤니티",
      "application": "앱 및 자료",
      "my": "계정 센터",
      "tool": "도구",
      "hitNewRobot": "신규 토큰 봇",
      "contractCheck": "컨트랙트 점검"
    }
  }
};
